import headerComponent from '@/components/cust_components/cust_header_component.vue';
import CustPopover from '@/components/cust_components/cust_popover_component.vue';
import FooterComponent from '@/components/cust_components/cust_footer_component.vue';
import utils from '../../js/utils.js';
import moment from 'moment';
import 'moment-timezone';
import LoaderPopover from '@/components/loaderpopover_component.vue';


export default {
    name: 'previewBooking',
    components: {
        headerComponent,
        CustPopover,
        FooterComponent,
        LoaderPopover,
    },
    data() {
        return {
            mobile_view: false,
            sub_total: 0,
            deposit_to_be_paid: 0,
            due_amount: 0,
            all_bookings: [],
            product_details: [],
            store_data: [],
            service_obj: [],
            product_obj: [],
            book_id: '',
            multi_book_id: '',
            book_status: '',
            cancel_booking: false,
            cancelled_booking: false,
            reschedule_multi_booking: false,
            cancel_single_booking: false,
            cancel_24hrs_popup: false,
            cust_name: '',
            cust_mobile: '',
            cust_email: '',
            book_start_date: '',
            book_start_time: '',
            hours_diff: '',
            paymentMethod: '',
            banned: false,
            service_bookings_length: '',
            store_mobile: this.$session.get('store_details') ? JSON.parse(this.$session.get('store_details')).store_mobile : '',
            today_date: this.$store.state.brisbane_today_date,
            today_time: this.$store.state.brisbane_today_time,
            banned_data: this.$session.get('cust_banned_data') ? JSON.parse(this.$session.get('cust_banned_data')).cust_banned : '',
            block_customer_popup: false,
            rechedule_24hrs_popup: false,
            payment_types_array: [],

        }
    },
    mounted() {
        this.getStoreDetails();
        this.getBookingDetailsEachCustomer();
        this.responsive_view();
        window.addEventListener('resize', this.responsive_view);
    },
    methods: {
        close_block_customer_popup() {
            this.block_customer_popup = false;
        },
        async responsive_view() {
            await this.$store.commit('responsive_view', window.innerWidth)
        },
        async getBookingDetailsEachCustomer() {
            this.$store.state.loader_popup = true;
            await this.$store.dispatch('getBookingDetailsEachCustomer', [this.$store.state.api, this.$route.params.type, this.$route.params.book_id, this.$route.params.multi_service_book_id])
            let bookings = this.$store.state.booking_details_each_customer_data.service_booking_details;
            this.service_bookings_length = bookings.length;
            if (Object.keys(this.$store.state.booking_details_each_customer_data.product_booking_details).length > 0) {
                this.product_details = this.$store.state.booking_details_each_customer_data.product_booking_details;
            } else {
                this.product_details = [];
            }

            this.cust_name = bookings[0].cust_name;
            this.cust_mobile = bookings[0].cust_mobile;
            this.cust_email = bookings[0].cust_email;
            this.book_start_date = bookings[0].slot_date;
            this.book_start_time = bookings[0].slot_start_time;
            for (var j = 0; j < bookings.length; j++) {
                let temp_array = {};
                temp_array.book_start_date = bookings[j].slot_date;
                temp_array.book_id = bookings[j].booking_id;
                this.book_id = this.service_bookings_length == 1 ? bookings[j].booking_id : bookings[j].multi_service_book_id;
                this.book_status = bookings[j].book_status
                temp_array.multi_book_id = bookings[j].multi_service_book_id;
                temp_array.service_bookings = [];
                if (!this.all_bookings.some(book => book.book_start_date == bookings[j].slot_date)) {

                    for (let i = 0; i < bookings.length; i++) {

                        if (bookings[i].slot_date == temp_array.book_start_date) {
                            temp_array.service_bookings.push(bookings[i]);
                        }
                    }
                }
                if (temp_array.service_bookings.length) {

                    this.all_bookings.push(temp_array)
                }

                this.payment_types_array.push(bookings[j].payment_type1);
                this.payment_types_array.push(bookings[j].payment_type2);
            }

            for (var booking_index = 0; booking_index < bookings.length; booking_index++) {
                if (bookings[booking_index].book_discount_full_amount >= 0) {
                    this.sub_total += parseFloat(bookings[booking_index].book_discount_full_amount);
                } else {
                    this.sub_total += parseFloat(bookings[booking_index].book_fullamount);
                }

                this.deposit_to_be_paid += parseFloat(bookings[booking_index].paid_amount);
            }

            this.product_details.forEach(product => {
                this.payment_types_array.push(product.payment_type1);
                this.payment_types_array.push(product.payment_type2);

                if (product.product_discount_full_amount >= 0) {
                    this.sub_total += parseFloat(product.product_discount_full_amount) * product.product_quantity;
                } else {
                    this.sub_total += parseFloat(product.product_full_amount) * product.product_quantity;
                }

                this.deposit_to_be_paid += parseFloat(product.product_paid_amount);
            });

            this.payment_types_array = [...new Set(this.payment_types_array)];

            this.custPayableMethod();
            this.due_amount = parseFloat(this.sub_total).toFixed(2) - parseFloat(this.deposit_to_be_paid).toFixed(2);
            if (this.all_bookings[0].service_bookings[0].book_status == this.Constants.STATUS_EARLY_CANCELLED) {
                this.due_amount = 0;
            }

            let appoint_date = moment(this.book_start_date).format('MMM D, YYYY') + " " + moment(this.book_start_time, ["HH:mm A"]).format('hh:mm A');

            let today_format = moment().tz('Australia/Brisbane').format("YYYY-MM-DD HH:mm:ss");

            let appoint_date_format = moment(appoint_date);

            this.hours_diff = moment.duration(appoint_date_format.diff(today_format)).asHours();

            this.$store.state.loader_popup = false;

        },

        custPayableMethod() {
            if (this.payment_types_array) {
                this.payment_types_array.forEach(payment_type => {
                    if (payment_type == 0) {
                        this.paymentMethod += " Cash,"
                    } else if (payment_type == 1) {
                        this.paymentMethod += " Debit/Credit Card (Stripe),"
                    } else if (payment_type == 2) {
                        this.paymentMethod += " Paypal,"
                    } else if (payment_type == 3) {
                        this.paymentMethod += " Afterpay,"
                    } else if (payment_type == 4) {
                        this.paymentMethod += " Wallet,"
                    } else if (payment_type == 5) {
                        this.paymentMethod += " Point Of Sale,"
                    } else if (payment_type == 6) {
                        this.paymentMethod += " Debit/Credit Card (Square),"
                    }
                })

            }

            this.paymentMethod = this.paymentMethod.substring(0, this.paymentMethod.length - 1);

        },

        cancelbooking() {
            if (this.$session.get('cust_details')) {
                if (this.banned_data == 1) {
                    this.block_customer_popup = true;
                } else {
                    if (this.hours_diff > 24) {
                        if (this.service_bookings_length == 1) {
                            this.cancel_single_booking = true;
                        } else {
                            this.cancel_booking = true;
                        }

                    } else {
                        this.cancel_24hrs_popup = true;
                    }
                }
            } else {
                this.$router.push('/custlogin');
            }

        },

        async booking_cancel() {
            let booking_data = this.$store.state.booking_details_each_customer_data.service_booking_details[0]
            await this.$store.commit('service_status_update', [booking_data.booking_id, booking_data.multi_service_book_id, this.Constants.STATUS_EARLY_CANCELLED, JSON.parse(this.$session.get('cust_banned_data')).owner_cust_id, this.Constants.BOOKED_THROUGH_CUSTOMER]);
            this.cancel_single_booking = false;
            this.cancel_booking = false;
            this.cancelled_booking = true;
        },

        dashboard_redirection() {
            this.$router.push('/mybookings')
        },

        cancel_pop_close() {
            this.cancel_24hrs_popup = false;
            this.cancel_single_booking = false;
            this.cancel_booking = false;
            this.rechedule_24hrs_popup = false;
        },

        cancelled_pop_close() {
            this.cancelled_booking = false;
        },

        proceed_to_reschedule() {
            if (this.$session.get('cust_details')) {
                if (this.banned_data == 1) {
                    this.block_customer_popup = true;
                } else if (this.hours_diff < 24) {
                    this.rechedule_24hrs_popup = true;
                } else {
                    if (this.service_bookings_length == 1) {
                        let service_bookings = this.$store.state.booking_details_each_customer_data.service_booking_details;
                        for (var k = 0; k < service_bookings.length; k++) {
                            service_bookings[k].edit_flag = 1;
                            this.service_obj.push(service_bookings[k]);
                        }

                        this.$session.set('service_obj', JSON.stringify(this.service_obj));

                        let product_bookings = this.$store.state.booking_details_each_customer_data.product_booking_details;

                        product_bookings.forEach(prod => {

                            let prod_obj = {
                                "product_barcode": prod.product_barcode,
                                "product_default_image": {
                                    "product_image_url": prod.product_thumbnail_url,
                                    "product_thumbnail_url": prod.product_image_url,
                                },
                                "product_description": "",
                                "booking_old_product_id": prod.booking_old_product_id,
                                "booking_product_id": prod.booking_product_id,
                                "old_quantity": prod.product_quantity,
                                "product_book_notes": prod.product_book_notes,
                                "product_id": prod.product_id,
                                "product_name": prod.product_name,
                                "product_order": 0,
                                "product_price": prod.product_compare_price,
                                "product_quantity": prod.product_remaining_quantity,
                                "product_sale_price": prod.product_full_amount,
                                "product_sku": prod.product_sku,
                                "store_id": prod.store_id,
                                "quantity_selected": prod.product_quantity,
                                "product_discount_full_amount": prod.product_discount_full_amount,
                                "edit_flag": 1
                            }

                            this.product_obj.push(prod_obj);
                        })

                        this.$session.set('product_obj', JSON.stringify(this.product_obj));
                        this.$router.push('/cart');
                    } else {
                        this.reschedule_multi_booking = true;
                    }
                }

            } else {
                this.$router.push('/custlogin');
            }
        },
        async getStoreDetails() {

            await this.$store.dispatch('getStoreDetails', [this.$store.state.api, this.$store.state.store_url_name])

            if (Object.keys(this.$store.state.cust_store_data).length > 0) {
                this.store_data = this.$store.state.cust_store_data;
            } else {
                this.store_data = [];
            }

        },

        multibook_reschedule_pop_close() {
            this.reschedule_multi_booking = false;
        },
        redirect_backPage() {
            this.$router.push('/mybookings')
        }
    },
    filters: {
        human_date_format: function(date, timezone, date_format) {
            return utils.human_date_format(date, timezone, date_format)
        },
        time_12hrs_format: function(time, time_format) {
            return utils.time_12hrs_format(time, time_format)
        }

    }
}